import React, {Component} from "react";
import {get as getDoorVisualisation} from "../../../services/http/doorVisualisationService";
import {getApiUrl, putWithJWT} from "../../../services/http/httpService";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";

class MobileDoorVisualisationListForm extends Component {
    state = {
        dataList: [],
        data: {}
        // showModal: false,
    };

    componentDidMount = async () => {
        await this.onRefresh();

        this.myInterval = setInterval(async () => {
            await this.onRefresh();
        }, 10000);

    };

    onRefresh = async () => {
        const request = await getDoorVisualisation(
            this.props.credentials,
            getApiUrl() +
            "/" +
            "secClockworkDoorVisualisation"
        );

        this.createDataList(
            request.data.data.terminalsMap
        );
    };

    createDataList = (terminalsMap) => {

        const terminalList = terminalsMap ? Object.entries(terminalsMap) : []
        const dataList = [];

        for (const record of terminalList) {
            const data = {
                terminalId: record[0],
                description: record[1].description,
                firmwareVersion: record[1].firmwareVersion,
                lastKeepAlive: record[1].lastKeepAliveString ? record[1].lastKeepAliveString : "",
                mode: record[1].mode,
                generalOpen: record[1].generalOpen,
                inputState: record[1].inputState,
                // input1: record[1].input1,
                // input2: record[1].input2,
                // input3: record[1].input3,
                // input4: record[1].input4,
                officeByPersonActive: record[1].officeByPersonActive,
                officeWithEndTimeString: record[1].officeWithEndTimeString,
                generallyOpenByPersonActive: record[1].generallyOpenByPersonActive,
                generallyOpenWithEndTimeString: record[1].generallyOpenWithEndTimeString,
                generallyCloseByPersonActive: record[1].generallyCloseByPersonActive,
                generallyCloseWithEndTimeString: record[1].generallyCloseWithEndTimeString,
                todos: record[1].todos
            };

            dataList.push(data);
        }

        this.setState({dataList});
    };

    onChangeMode = async (terminalId, mode) => {

        const request = await putWithJWT(
            this.props.credentials,
            getApiUrl() + "/secClockworkDoorVisualisation",
            {
                terminalId: terminalId,
                mode: mode,
            }
        );
        this.onRefresh()

    };

    renderCenter = (text) => {

        return (
            <div
                style={{
                    textAlign: "center"
                }}
            >
                {text}
            </div>
        );
    }

    renderNormalModeButton = (terminalId) => {
        return (
            <button
                className="btn btn-light btn-sm"
                value={"warning"}
                onClick={() => {
                    this.onChangeMode(terminalId, 1);
                }}
            >
                {"normal"}
            </button>
        )
    }
    renderGenerallyOpenedModeButton = (terminalId) => {
        return (
            <button
                className="btn btn-light btn-sm"
                value={"warning"}
                onClick={() => {
                    this.onChangeMode(terminalId, 2);
                }}
            >
                {"generell offen"}
            </button>
        )
    }
    renderGenerallyClosedModeButton = (terminalId) => {
        return (
            <button
                className="btn btn-light btn-sm"
                value={"warning"}
                onClick={() => {
                    this.onChangeMode(terminalId, 3);
                }}
            >
                {"generell geschlossen"}
            </button>
        )
    }

    renderMode = (cellInfo) => {

        switch (cellInfo.row._original.mode) {
            case 1:
                return (
                    <React.Fragment>
                        <h5>Normalbetrieb</h5>
                        {this.renderNormalModeButton(cellInfo.row._original.terminalId)}
                        {this.renderGenerallyOpenedModeButton(cellInfo.row._original.terminalId)}
                        {this.renderGenerallyClosedModeButton(cellInfo.row._original.terminalId)}
                    </React.Fragment>
                );
            case 2:
                return (
                    <React.Fragment>
                        <h5>generell offen (Software)</h5>
                        {this.renderNormalModeButton(cellInfo.row._original.terminalId)}
                        {this.renderGenerallyOpenedModeButton(cellInfo.row._original.terminalId)}
                        {this.renderGenerallyClosedModeButton(cellInfo.row._original.terminalId)}
                    </React.Fragment>
                );
            case 3:
                return (
                    <React.Fragment>
                        <h5>generell geschlossen (Software)</h5>
                        {this.renderNormalModeButton(cellInfo.row._original.terminalId)}
                        {this.renderGenerallyOpenedModeButton(cellInfo.row._original.terminalId)}
                        {this.renderGenerallyClosedModeButton(cellInfo.row._original.terminalId)}
                    </React.Fragment>
                );
            case 99:
                return (
                    <React.Fragment>
                        <h5>an Türe durch Person geändert</h5>
                        {this.renderNormalModeButton(cellInfo.row._original.terminalId)}
                        {this.renderGenerallyOpenedModeButton(cellInfo.row._original.terminalId)}
                        {this.renderGenerallyClosedModeButton(cellInfo.row._original.terminalId)}
                    </React.Fragment>
                );
            default:
                return (
                    <React.Fragment>
                        <h5>keine Rückmeldung</h5>
                        {this.renderNormalModeButton(cellInfo.row._original.terminalId)}
                        {this.renderGenerallyOpenedModeButton(cellInfo.row._original.terminalId)}
                        {this.renderGenerallyClosedModeButton(cellInfo.row._original.terminalId)}
                    </React.Fragment>
                );
        }
    };

    renderInputState = (cellInfo) => {
        return (
            <React.Fragment>
                {(cellInfo.row._original.inputState === 1 && <p>Türe offen</p>)}
                {(cellInfo.row._original.inputState === 2 && <p>Türe geschlossen</p>)}
                {(cellInfo.row._original.generalOpen === true && <p>generell-offen-Plan</p>)}
                {(cellInfo.row._original.officeByPersonActive === true &&
                    <p>Office-Funktion durch
                        Person {cellInfo.row._original.officeWithEndTimeString.length > 0 ? "(bis " + cellInfo.row._original.officeWithEndTimeString + ")" : ""}</p>)}
                {(cellInfo.row._original.generallyOpenByPersonActive === true &&
                    <p>generall geöffnet durch
                        Person {cellInfo.row._original.generallyOpenWithEndTimeString.length > 0 ? "(bis " + cellInfo.row._original.generallyOpenWithEndTimeString + ")" : ""}</p>)}
                {(cellInfo.row._original.generallyCloseByPersonActive === true &&
                    <p>generell geschlossen durch
                        Person {cellInfo.row._original.generallyCloseWithEndTimeString.length > 0 ? "(bis " + cellInfo.row._original.generallyCloseWithEndTimeString + ")" : ""}</p>)}
            </React.Fragment>
        );
    };

    render = () => {
        const {
            dataList
        } = this.state;
        const {
            // onSaveAbsence,
            // onDeleteAbsence,
            // onCloseModal,
            // onChangeAbsence,
            renderModeColumn
        } = this;
        let columns = [];

        const ReactTableFixedColumns = withFixedColumns(ReactTable);

        const thStyle = (state, rowInfo, column, instance) => {
            return {
                style: {
                    // fontSize: "x-small",
                    padding: "2px 2px",
                    margin: "0"
                    //          height: "30px"
                }
            };
        };
        const tdStyle = (state, rowInfo, column, instance) => {
            return {
                style: {
                    // fontSize: "x-small",
                    padding: "2px 2px",
                    margin: "0",
                    background: rowInfo.row._original.type === "department" ? "lightsalmon" :
                        (rowInfo.row._original.type === "costUnit" ? "lightyellow" :
                            (rowInfo.row._original.type === "timeTimeModel" ? "lightgreen" :
                                (rowInfo.row._original.type === "absence" ? "lightcoral" :
                                    (rowInfo.row._original.type === "unused" ? "lightblue" : ""))))
                }
            }
        };

        columns.push({
            Header: (
                <React.Fragment>
                </React.Fragment>
            ),
            // fixed: "left",
            columns: [],
        });

        columns[0].columns.push({
            Header: "Beschreibung",
            accessor: "description"
            // fixed: "left",
            // Cell: (cellInfo) => this.renderName(cellInfo),
        });
        columns[0].columns.push({
            Header: "Modus",
            accessor: "mode",
            Cell: (cellInfo) => this.renderMode(cellInfo)
        });
        columns[0].columns.push({
            Header: "Zustand",
            accessor: "inputState",
            Cell: (cellInfo) => this.renderInputState(cellInfo)
        });
        columns[0].columns.push({
            Header: "Firmware",
            accessor: "firmwareVersion",
            Cell: (cellInfo) => this.renderCenter(cellInfo.row._original.firmwareVersion),
            width: 100
        });
        columns[0].columns.push({
            Header: "Todos",
            accessor: "todos",
            Cell: (cellInfo) => this.renderCenter(cellInfo.row._original.todos),
            width: 100
        });
        columns[0].columns.push({
            Header: "letzte Kommunikation",
            accessor: "lastKeepAlive",
            Cell: (cellInfo) => this.renderCenter(cellInfo.row._original.lastKeepAlive),
            width: 200
        });

        return (
            <React.Fragment>
                <ReactTableFixedColumns
                    columns={columns}
                    data={dataList}
                    defaultPageSize={dataList.length}
                    showPagination={false}
                    getTheadThProps={thStyle}
                    // getTrProps={trStyle}
                    getTdProps={tdStyle}
                    // style={{height: window.innerHeight}}
                />
                {/*)}*/}
            </React.Fragment>
        );
    }
}

export default MobileDoorVisualisationListForm;
